<script>
    import {Listeners} from "../../../constants/listeners";
    import AdaptersDialog from "../../../component/adapters/Dialog.vue";
    import Button from "primevue/button";
    import Fieldset from "primevue/fieldset";
    import RadioButton from "primevue/radiobutton";

    export default {
        data () {
            return {
                name:"TreeExport",
                model: {
                    exportType: 0
                }
            }
        },
        props: ["base", "domain"],

        methods: {
            doExportCluster(){
                let self = this;
                window.open(this.getApiUrl, '_blank');

                setTimeout(function() {
                    self.onClose();
                }, 500);
            },
            onClose() {
                this.$emitter.emit(this.getDialogListenerCloseId);
            },
            onOpen() {
                this.$emitter.emit(this.getDialogListenerOpenId);
            }
        },
        computed: {
            getApiUrl(){
                return this.$config.API_URL + '/report/simple/organic/tree_pages/export?base=' + this.base + '&domain=' + this.domain + '&type=' + this.model.exportType;
            },
            getDialogListenerOpenId() {
                return Listeners.TREE_PAGES_POPUP_EXPORT_OPEN;
            },
            getDialogListenerCloseId() {
                return Listeners.TREE_PAGES_POPUP_EXPORT_CLOSE;
            }
        },
        components: {
            AdaptersDialog,
            Button,
            Fieldset,
            RadioButton,
        },
    }
</script>
<template>
    <div class="flex-wrap flex flex-column sm:flex-row gap-2 w-full sm:w-auto">
        <Button
            :label="$t('lang.report.treepages.export')"
            icon="fa fa-file-o"
            @click="onOpen"
            :title="$t('lang.report.treepages.export_csv_helper')"
            size="small"
            :pt="{
                icon: { class: 'hidden sm:block' }
            }"
        />

        <AdaptersDialog
            :listener-id="getDialogListenerOpenId"
            :listener-close-id="getDialogListenerCloseId"
            :header="$t('lang.report.treepages.export_setting')"
            :callback-agree="doExportCluster"
            :button-agree-label="$t('lang.main.btn.loading_c')"
        >
            <template #content>
                <Fieldset :legend="$t('lang.report.treepages.common')">
                    <div class="field-radiobutton">
                        <RadioButton v-model="model.exportType" inputId="exportKeyColl" :value="0" />
                        <label for="exportKeyColl">{{ $t('lang.report.treepages.format_key_coll') }}</label>
                    </div>
                    <div class="field-radiobutton">
                        <RadioButton v-model="model.exportType" inputId="exportStructureStat" :value="1" />
                        <label for="exportStructureStat">{{ $t('lang.report.treepages.format_structure_stat') }}</label>
                    </div>
                    <div class="field-radiobutton">
                        <RadioButton v-model="model.exportType" inputId="exportStructureXmind" :value="2" />
                        <label for="exportStructureXmind">{{ $t('lang.report.treepages.format_tree_xmind') }}</label>
                    </div>
                </Fieldset>
            </template>
        </AdaptersDialog>

    </div>
</template>
